export async function fetchLocations(vendorId: string) {
  const response = await fetch(`/api/vendor/${vendorId}/locations`);
  if (!response.ok) throw new Error('Failed to fetch coupon');
  return await response.json();
}
